import React from 'react';
import { Body } from '@grnhse/seedling/lib/birch/typography';
import ConfirmationModal from '@grnhse/seedling/lib/birch/components/modals/confirmation_modal';
import {
  DestructiveButton,
  SecondaryButton,
} from '@grnhse/seedling/lib/birch/components/buttons';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching.modals.calibration.delete_modal');

type Props = {
  isOpen: boolean;
  close: () => void;
  onDelete: () => void;
};

const DeleteConfirmationModal = ({ isOpen, close, onDelete }: Props) => {
  return (
    <ConfirmationModal
      isOpen={isOpen}
      onDismiss={close}
      ariaLabel="Delete Calibration"
    >
      <ConfirmationModal.Header destructive>
        {t('title')}
      </ConfirmationModal.Header>
      <ConfirmationModal.Body>
        <Body>{t('description')}</Body>
      </ConfirmationModal.Body>
      <ConfirmationModal.Footer>
        <SecondaryButton onClick={close}>{t('cancel')}</SecondaryButton>
        <DestructiveButton onClick={onDelete}>{t('delete')}</DestructiveButton>
      </ConfirmationModal.Footer>
    </ConfirmationModal>
  );
};

export default DeleteConfirmationModal;
